import { createFileRoute } from '@tanstack/react-router'
import { VerifyCertificateScreen } from '@web/app/features/publicVerify'

// Definimos la estructura de nuestros parámetros de búsqueda
type CertificateSearch = {
  id?: string // Lo ponemos opcional por si entran a la URL vacía
}

export const Route = createFileRoute('/verificarCertificado')({
  // Validamos los parámetros de búsqueda
  validateSearch: (search: Record<string, unknown>): CertificateSearch => {
    return {
      id: (search.id as string) || undefined,
    }
  },
  component: VerifyCertificateScreen,
})
